import styled, { css } from 'styled-components';
import { Chip as ChipComponent } from '@/components/UI/Chip/Chip';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div<{ $withOverflow?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 30px;
  width: 270px;
  margin-bottom: 0;
  top: calc(var(--header-visible-h, 0px) + 40px);
  max-height: auto;
  overflow-y: ${({ $withOverflow }) => ($withOverflow ? 'visible' : 'auto')};

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RangeFieldsContainer = styled.div`
  display: flex;
  gap: 15px;
`;

export const BooleanOptionsContainer = styled(RangeFieldsContainer)`
  gap: 10px;
`;

export const Chip = styled(ChipComponent)`
  height: 40px;
  border-radius: 100px;
  user-select: none;
`;

export const LinkOption = styled(CustomLink)<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 15px;
  height: 30px;
  padding: 5px 0;
  cursor: pointer;
  transition: all 0.1s linear;

  &:hover {
    & > .radio {
      border-color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const LinkOptionText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RadioButton = styled.div.attrs({ className: 'radio' })<{
  $isActive: boolean;
}>`
  position: relative;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.palette.brand.main : theme.palette.secondary.border};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.white};

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 11px;
    height: 11px;
    border-radius: 50%;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    background-color: ${({ theme }) => theme.palette.brand.main};
    display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  }
`;

export const SearchInput = styled.input<{ $hasBottomMargin?: boolean }>`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
  font-weight: 400;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.quartenary.background};
  padding: 10px 15px;
  height: 44px;
  width: 100%;
  ${({ $hasBottomMargin }) =>
    $hasBottomMargin &&
    css`
      margin-bottom: 10px;
    `}
  margin-top: 10px;

  &:focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.palette.brand.main};
    background: ${({ theme }) => theme.palette.primary.background};
  }

  &::placeholder {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;

export const NothingFound = styled(Typography.Caption).attrs({ $variant: '2' })`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const DesktopFilterLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};
`;

export const DesktopFilterLoaderRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
